import React from "react";
import Pagination from "../../../../utils/admin/pagination/Pagination";

const ClientWiseCategory = ({
  categoriesByClient,
  start,
  end,
  totalClients,
  handleNextPage,
  handlePrevPage,
  isNextDisabled,
  isPrevDisabled,
}) => {
  return (
    <div className="table-responsive mx-4" style={{ marginBottom: "5%" }}>
      <table className="table table-borderless mb-0 clientsTable">
        <thead>
          <tr
            className="text-muted"
            style={{ fontSize: "12px", borderBottom: "1px solid lightgray" }}
          >
            <th style={{ width: "5%" }}>Sr #</th>
            <th style={{ width: "20%" }}>Client Name</th>
            <th>Assigned Categories</th>
          </tr>
        </thead>
        <tbody>
          {categoriesByClient.length > 0 ? (
            categoriesByClient.map((client, index) => (
              <tr key={index}>
                <td>{start + index}</td>
                <td>{client.name}</td>
                <td>{client.categories.join(", ")}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-muted">
                No Categories Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination
        start={start}
        end={end}
        totalRecord={totalClients}
        isPrevDisabled={isPrevDisabled}
        isNextDisabled={isNextDisabled}
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
      />
    </div>
  );
};

export default ClientWiseCategory;
